import { Template } from './reducer'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { AxiosError, AxiosResponse } from 'axios'
import {
  DeleteIntegrationFailureMessage,
  DeleteIntegrationSuccessMessage,
  RequestFailureMessage,
} from '../../../common/utils/messagesContants'
import { AppDispatch, RootState } from '../../../store'
import { camelize, snakeize } from 'casing'
import { getErrorMessages } from '../../../common/utils/error'
import { errorLogger } from '../../../common/utils/errorLogger'
import {
  deleteIntegration,
  getIntegrationsData,
  getTemplatesData,
} from '../../api/markeplace'
import { IntegrationData } from './templateCreation/reducer'
import integrationsListingMock from '../../../mocks/integrationsListingMock.json'
import { isEmpty } from 'lodash'
import { LoadingTypes, startLoading, stopLoading } from '@labrav/common'
export enum StorefrontActionTypes {
  SET_TEMPLATES_DATA = 'SET_TEMPLATES_DATA',
  SET_INTEGRATIONS_DATA = 'SET_INTEGRATIONS_DATA',
  CLEAR_INTEGRATIONS_DATA = 'CLEAR_INTEGRATIONS_DATA',
}

export const getTemplates =
  () => async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.TEMPLATES))

    try {
      const partnerId = getState().AccountData.user.partnerData?.partnerId || ''

      const { data } = await getTemplatesData(partnerId)
      await dispatch(setTemplatesData(camelize(data)))
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.TEMPLATES))
    }
  }
export const getListingIntegrations =
  () => async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))

    try {
      const partnerId = getState().AccountData.user.partnerData?.partnerId || ''

      const { data } = await getIntegrationsData(partnerId)
      await dispatch(setListingIntegrationsData(camelize(data)))
    } catch (error: any) {
      // Remove when not required
      await dispatch(
        setListingIntegrationsData(camelize(integrationsListingMock))
      )

      const e = error as AxiosError
      const errorResponse = e.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const deleteSelectedIntegration =
  (integrationId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      const partnerId = getState().AccountData.user.partnerData?.partnerId || ''
      await deleteIntegration(partnerId, integrationId)
      await clearIntegrationsData()
      await dispatch(getListingIntegrations())
      dispatch(
        updateAppAlert({
          message: DeleteIntegrationSuccessMessage,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([DeleteIntegrationFailureMessage])(
            errorResponse
          ),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }
export const setTemplatesData = (templates: Template[]) => ({
  type: StorefrontActionTypes.SET_TEMPLATES_DATA,
  payload: templates,
})

export const setListingIntegrationsData = (
  integrations: IntegrationData[]
) => ({
  type: StorefrontActionTypes.SET_INTEGRATIONS_DATA,
  payload: integrations,
})
export const clearIntegrationsData = () => ({
  type: StorefrontActionTypes.CLEAR_INTEGRATIONS_DATA,
})
